// You can write more code here

import DynamicSortByY from '@/game/GameComponents/PhaserGame/Utils/DynamicSortByY';

/* START OF COMPILED CODE */

import Mentor from './Mentor';
/* START-USER-IMPORTS */
import _ from 'lodash';
/* END-USER-IMPORTS */

export default class Mentor4 extends Mentor {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // mentorSprite
    const mentorSprite = scene.add.sprite(0, 0, 'npc-mentor-d-spritesheet', 0);
    mentorSprite.setOrigin(0.5, 0.68);
    this.add(mentorSprite);

    this.mentorSprite = mentorSprite;

    /* START-USER-CTR-CODE */
    new DynamicSortByY(this, this.scene);
    this.mentorSprite.play('mentor-d-idle-0');
    /* END-USER-CTR-CODE */
  }

  private mentorSprite: Phaser.GameObjects.Sprite;

  /* START-USER-CODE */

  override createAnimations() {
    if (!this.scene.cache.json.exists('mentor4-pack')) {
      this.mentorSprite.setVisible(false); // Hide the mentor until the animations are loaded.
      this.scene.load.pack(
        'mentor4-pack',
        'game_assets/animations/mentors/mentor4-pack.json',
      );
      this.scene.load.start();
      this.scene.load.once('complete', () => {
        this.mentorSprite.setVisible(true); // Show the mentor once the animations are loaded.
        this.mentorSprite.anims.play('mentor-d-idle-0');
        this.animInterval = setInterval(() => {
          const randomIdleAnimKey = _.sample([
            'mentor-d-idle-1',
            'mentor-d-idle-2',
          ]);
          this.mentorSprite.play({
            key: randomIdleAnimKey,
            repeat: 0,
          });
          this.mentorSprite.on(`animationcomplete-${randomIdleAnimKey}`, () => {
            this.mentorSprite.play('mentor-d-idle-0');
          });
        }, 5000);
      });
    }
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
